module.exports = __webpack_public_path__ + "img/logo.d1050ad0.png";